import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import ICU from 'i18next-icu';

import en from '@/messages/en.json';
import ko from '@/messages/ko.json';
import zh from '@/messages/zh.json';
import vi from '@/messages/vi.json';

type MessageBundle = Record<string, Record<string, unknown>>;

function toNamespaces(bundle: MessageBundle): Record<string, Record<string, unknown>> {
  const ns: Record<string, Record<string, unknown>> = {};
  for (const [key, value] of Object.entries(bundle)) {
    ns[key] = value as Record<string, unknown>;
  }
  return ns;
}

i18n
  // ICU MessageFormat parser — the message bundles use next-intl-style ICU
  // syntax (single-brace `{var}` interpolation + `{n, plural, …}` / `{x, select, …}`),
  // which plain i18next does NOT understand (it expects `{{var}}` + `_one`/`_other`
  // suffix keys). Without this, ICU strings render raw (e.g. "{count}d left").
  .use(new ICU())
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: toNamespaces(en as MessageBundle),
      ko: toNamespaces(ko as MessageBundle),
      zh: toNamespaces(zh as MessageBundle),
      vi: toNamespaces(vi as MessageBundle),
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'ko', 'zh', 'vi'],
    ns: [
      'access',
      'appointment', 'auditTrail', 'auth', 'checkOff', 'claims', 'commission', 'common', 'customers', 'customerTickets',
      'dailyReport', 'dashboard', 'editShift', 'finance', 'forms', 'inventory', 'leave', 'lifestyleSurvey', 'marketing',
      'mediation', 'meetings', 'nav', 'outlets', 'promotion', 'questionnaires', 'reports', 'rooms', 'salary', 'schedule', 'review',
      'settings', 'shiftTypes', 'staff', 'training', 'treatments', 'users', 'yaksonAi',
    ],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['path'],
      lookupFromPathIndex: 0,
    },
  });

export default i18n;
